import "../_namespaces.js";
import "./base.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Models ??= {};

AssessmentViewer.Models.Question = class Question extends AssessmentViewer.Models.Base {
  constructor() {
    super(...arguments);
    this.selectedResponsePoints = this.selectedResponsePoints.bind(this);
    this.hasSelectedResponse = this.hasSelectedResponse.bind(this);
    this.resetResponses = this.resetResponses.bind(this);
    this.getSelectedResponses = this.getSelectedResponses.bind(this);
    this.getResponseExplanation = this.getResponseExplanation.bind(this);
  }

  defaults() {
    return {
      allowExplanation: null,
      response_explanation: null, // User's explanation of why they chose the given response.
      image: null,
    };
  }

  selectedResponsePoints() {
    return _.map(this.getSelectedResponses(), (response) => parseFloat(response.get("points")));
  }

  hasSelectedResponse() {
    return this.getSelectedResponses().length;
  }

  resetResponses() {
    return _.each(this.getSelectedResponses(), (response) => {
      if (this.get("responseType") === "free_text") {
        return response.set({ selected: false, text: "" });
      } else {
        return response.set({ selected: false });
      }
    });
  }

  getSelectedResponses() {
    return this.get("responses").selected();
  }

  getResponseExplanation() {
    return this.get("response_explanation");
  }
};

AssessmentViewer.Models.Question.prototype.relations = [
  {
    type: Backbone.HasMany,
    key: "responses",
    relatedModel: "AssessmentViewer.Models.Response",
    collectionType: "AssessmentViewer.Collections.Responses",
    reverseRelation: {
      key: "question",
    },
  },
];

AssessmentViewer.Models.Question.initializeRelations();
